import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";

import { useStyles } from "./AdminHeader.css";
import AdminDrawer from "./AdminDrawer/AdminDrawer";
import AdminBar from "./AdminBar/AdminBar";
import { connect } from "react-redux";
import Axios from "axios";
import { url } from "../../../../Config/Config";

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = { open: true, schoolDetails: {} };
  }

  componentDidMount() {
    this.getSchoolDetails();
  }

  getSchoolDetails = async () => {
    const response = await Axios.get(`${url}/api/setting`);
    if (response.data) {
      this.setState({
        schoolDetails: response.data,
      });
    }
  };

  handleDrawerOpen = () => {
    this.setState({
      open: true,
    });
  };

  handleDrawerClose = () => {
    this.setState({
      open: false,
    });
  };

  render() {
    const { classes } = this.props;
    const { open, schoolDetails } = this.state;
    return (
      <div>
        <AdminBar
          open={open}
          schoolDetails={schoolDetails}
          handleDrawerOpen={this.handleDrawerOpen}
        />
        <div className={classes.sectionDesktop}>
          <AdminDrawer
            open={open}
            schoolDetails={schoolDetails}
            role={this.props.role}
            handleDrawerClose={this.handleDrawerClose}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    adminToken: state.AdminReducer.adminToken,
    refreshToken: state.AdminReducer.refreshToken,
    role: state.AdminReducer.role,
    isAdmin: state.AdminReducer.isAdmin,
  };
};

export default connect(mapStateToProps, null)(withStyles(useStyles)(Header));
